import {Routes} from '@angular/router'
import {AuthenticatedLayoutComponent} from '@core/authenticated-layout/pages/authenticated-layout.component'

export const routes: Routes = [
  {path: 'login', loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule)},
  {
    path: 'private',
    component: AuthenticatedLayoutComponent,
    loadChildren: () => import('./private/private.module').then((m) => m.PrivateModule),
  },
  {path: '**', redirectTo: 'login'},
]
